import React, { useState } from 'react';
import { useEffect, useRef } from 'react';

const JobFilters = ({
    isMobile = false,
    searchQuery,
    setSearchQuery,
    selectedEmployment,
    setSelectedEmployment,
    selectedSalaries,
    setSelectedSalaries,
    selectedCategory,
    setSelectedCategory,
    salaryOptions,
    employmentOptions,
    categoryOptions,
}) => {
    const [showMoreOptions, setShowMoreOptions] = useState(false);
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const [showEmploymentDropdown, setShowEmploymentDropdown] = useState(false);
    const [showSalaryDropdown, setShowSalaryDropdown] = useState(false);

    const categoryRef = useRef();
    const employmentRef = useRef();
    const salaryRef = useRef();

    const toggleMobileFilters = () => setShowMobileFilters(!showMobileFilters);
    const closeMobileFilters = () => setShowMobileFilters(false);

    const handleEmploymentOptionChange = (event) => {
        const value = event.target.value;
        if (event.target.checked) {
            setSelectedEmployment([...selectedEmployment, value]);
        } else {
            setSelectedEmployment(selectedEmployment.filter((employment) => employment !== value));
        }
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (categoryRef.current && !categoryRef.current.contains(e.target)) {
                setShowCategoryDropdown(false);
            }
            if (employmentRef.current && !employmentRef.current.contains(e.target)) {
                setShowEmploymentDropdown(false);
            }
            if (salaryRef.current && !salaryRef.current.contains(e.target)) {
                setShowSalaryDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const renderFilters = () => (

        <div className="filer_more_op">
            <div className="filter-container">
                <div className="filter-desk">
                    <div className="row align-items-center">
                        <div className="col-12">
                            {showMoreOptions && (
                                <div className="filer_sub_buttons hstack gap-3">
                                    <div className="dropdown" ref={employmentRef}>
                                        <button
                                            className={`btn btn-secondary dropdown-toggle ${selectedEmployment.length > 0 ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => setShowEmploymentDropdown(!showEmploymentDropdown)}
                                        >
                                            {`Employment Type${selectedEmployment.length > 0 ? ` (${selectedEmployment.length})` : ''}`}
                                        </button>
                                        {showEmploymentDropdown && (
                                            <ul className="dropdown-menu show">
                                                <li>
                                                    <button className="dropdown-item" onClick={() => setSelectedEmployment([])}>
                                                        Clear Employment
                                                    </button>
                                                </li>
                                                {employmentOptions.map((option) => (
                                                    <li key={option.value}>
                                                        <label
                                                            htmlFor={`employment-option-${option.value}`}
                                                            className="dropdown-item"
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <input
                                                                className="form-check-input me-2"
                                                                type="checkbox"
                                                                value={option.value}
                                                                id={`employment-option-${option.value}`}
                                                                onChange={handleEmploymentOptionChange}
                                                                checked={selectedEmployment.includes(option.value.toString())}
                                                            />
                                                            {option.label}
                                                        </label>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>


                                    <div className="dropdown" ref={salaryRef}>
                                        <button
                                            className={`btn btn-secondary dropdown-toggle ${searchQuery.salaryRange ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => setShowSalaryDropdown(!showSalaryDropdown)}
                                        >
                                            {searchQuery.salaryRange
                                                ? salaryOptions.find((opt) => opt.value.toString() === searchQuery.salaryRange)?.label || 'Salary'
                                                : 'Salary'}
                                        </button>
                                        {showSalaryDropdown && (
                                            <ul className="dropdown-menu show">
                                                <li>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                            setSearchQuery({ ...searchQuery, salaryRange: null });
                                                            setShowSalaryDropdown(false);
                                                        }}
                                                    >
                                                        Clear Salary
                                                    </button>
                                                </li>
                                                {salaryOptions.map((option) => (
                                                    <li key={option.value}>
                                                        <label
                                                            htmlFor={`salary-option-${option.value}`}
                                                            className="dropdown-item"
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <input
                                                                className="form-check-input me-2"
                                                                type="radio"
                                                                name="salaryRange"
                                                                value={option.value}
                                                                id={`salary-option-${option.value}`}
                                                                onChange={(e) => {
                                                                    setSearchQuery({ ...searchQuery, salaryRange: e.target.value });
                                                                    setShowSalaryDropdown(false);
                                                                }}
                                                                checked={searchQuery.salaryRange === option.value.toString()}
                                                            />
                                                            {option.label}
                                                        </label>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>


                                    <div className="dropdown" ref={categoryRef}>
                                        <button
                                            type="button"
                                            className={`btn btn-secondary dropdown-toggle ${selectedCategory ? 'active' : ''}`}
                                            onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
                                        >
                                            {selectedCategory
                                                ? categoryOptions.find((cat) => cat.value.toString() === selectedCategory)?.label
                                                : 'Category'}
                                        </button>
                                        {showCategoryDropdown && (
                                            <ul className="dropdown-menu show">
                                                <li>
                                                    <button
                                                        className="dropdown-item"
                                                        onClick={() => {
                                                            setSelectedCategory('');
                                                            setSearchQuery({ ...searchQuery, categoryId: null });
                                                            setShowCategoryDropdown(false);
                                                        }}
                                                    >
                                                        Clear Category
                                                    </button>
                                                </li>
                                                {categoryOptions.map((category) => (
                                                    <li key={category.value}>
                                                        <button
                                                            className="dropdown-item"
                                                            onClick={() => {
                                                                setSelectedCategory(category.value.toString());
                                                                setSearchQuery({ ...searchQuery, categoryId: category.value });
                                                                setShowCategoryDropdown(false);
                                                            }}
                                                        >
                                                            {category.label}
                                                        </button>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>


                                    <button
                                        type="button"
                                        className={`btn btn-secondary ${searchQuery.sponsorship ? 'active' : ''}`}
                                        onClick={() =>
                                            setSearchQuery({
                                                ...searchQuery,
                                                sponsorship: searchQuery.sponsorship === true ? null : true, // Toggle between `null` and `true`
                                            })
                                        }
                                    >
                                        Sponsorship {searchQuery.sponsorship && <i className="bi bi-check-lg ms-2"></i>}
                                    </button>

                                    <button
                                        type="button"
                                        className={`btn btn-secondary ${searchQuery.remote ? 'active' : ''}`}
                                        onClick={() =>
                                            setSearchQuery({
                                                ...searchQuery,
                                                remote: searchQuery.remote === true ? null : true, // Toggle between `null` and `true`
                                            })
                                        }
                                    >
                                        Remote {searchQuery.remote && <i className="bi bi-check-lg ms-2"></i>}
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className="col-sm-auto col-12 mt-4 mt-sm-0">
                            {!showMoreOptions && (
                                <div className="hstack gap-2 justify-content-sm-end filer_sub_toggle">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-light border-base"
                                        onClick={() => setShowMoreOptions(!showMoreOptions)}
                                    >
                                        <span>Show more options </span>
                                        <span className="pe-2">
                                            <i className="bi bi-sliders rotate-icon"></i>
                                        </span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Mobile Filter Button */}
                <div className="mobile-filter-fpa">
                    <button
                        type="button"
                        className="btn btn-sm btn-light border-base mobile-filter-button"
                        onClick={toggleMobileFilters}
                    >
                        <i className="bi bi-sliders"></i>
                    </button>

                    {/*<input type="checkbox" id="mobile-filter-toggle" className="mobile-filter-checkbox" />*/}

                    {/*<label htmlFor="mobile-filter-toggle" className="mobile-filter-button">*/}
                    {/*    Filters <i className="bi bi-funnel"></i>*/}
                    {/*</label>*/}
                </div>

                {/* Mobile Full-Screen Filter Modal */}
                {showMobileFilters && (
                    <div className="mobile-filter-overlay">
                        <div className="mobile-filter-content">
                            <button className="filter-close-button" onClick={closeMobileFilters}>
                                <i className="bi bi-x-lg"></i>
                            </button>

                            <h2>Filter Jobs</h2>

                            <div className="filter-groups">
                                {/* Employment Type */}
                                <div className="filter-group">
                                    <h4>Employment Type</h4>
                                    <div className="filter-options">
                                        {employmentOptions.map((option) => (
                                            <label key={option.value} className="filter-box">
                                                <input
                                                    type="checkbox"
                                                    value={option.value}
                                                    onChange={handleEmploymentOptionChange}
                                                    checked={selectedEmployment.includes(option.value.toString())}
                                                />
                                                {option.label}
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                {/* Salary Range */}
                                <div className="filter-group">
                                    <h4>Salary</h4>
                                    <div className="filter-options">
                                        {salaryOptions.map((option) => (
                                            <label key={option.value} className="filter-box">
                                                <input
                                                    type="radio"
                                                    name="salaryRange"
                                                    value={option.value}
                                                    onChange={(e) =>
                                                        setSearchQuery({
                                                            ...searchQuery,
                                                            salaryRange: e.target.value,
                                                        })
                                                    }
                                                    checked={searchQuery.salaryRange === option.value.toString()}
                                                />
                                                {option.label}
                                            </label>
                                        ))}
                                    </div>
                                </div>

                                {/* Additional Filters */}
                                <div className="filter-group">
                                    <h4>Additional Filters</h4>
                                    <div className="filter-options">
                                        <label className={`filter-box ${searchQuery.sponsorship ? 'active' : ''}`}
                                            onClick={() => setSearchQuery({ ...searchQuery, sponsorship: searchQuery.sponsorship ? null : true })}
                                        >
                                            Sponsorship {searchQuery.sponsorship && <i className="bi bi-check-lg"></i>}
                                        </label>

                                        <label className={`filter-box ${searchQuery.remote ? 'active' : ''}`}
                                            onClick={() => setSearchQuery({ ...searchQuery, remote: searchQuery.remote ? null : true })}
                                        >
                                            Remote {searchQuery.remote && <i className="bi bi-check-lg"></i>}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <button className="apply-filters" onClick={closeMobileFilters}>Apply Filters</button>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );

    return renderFilters();
}

export default JobFilters;